var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAprendoleIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m236.3 44.67h-12.57v131.5c0 9.56-7.97 16.25-15.62 16.78-25.83 1.8-46.55 12.5-61.95 27.01l-0.12 0.14c19.1-8.97 39.29-12.7 60.94-12.7 9.05 0 17.23 0.77 28.11 1.63 5.94 0.49 8.39-4.08 8.39-7.86v-149c0-4.18-3.34-7.5-7.18-7.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.57 44.67h-11.89c-4.8 0-7.14 4.52-7.14 7.64v148c0 5.48 3.62 8.54 8.88 8.2 8.49-0.73 16.79-1.42 26.01-1.42 22.13 0 43.29 4.38 61.85 13.35-15.61-15.53-35.57-24.16-62.2-27.75-9.27-1.28-15.91-7.83-15.8-16.88l0.29-131.1z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m206.7 24.21c-29.93 0.86-58.66 14.68-81.95 38.7l-0.14 0.14-0.14-0.14c-23.29-24.02-52.02-37.84-81.95-38.7-5.72-0.17-7.78 4.61-7.78 8.39v142.9c0 5.17 3.44 8.38 7.99 8.38 28.04 2.85 52.2 14.81 70.24 33.6l4.98 4.91c2.86 2.51 8.8 2.51 11.88-0.81l5.65-5.9c18.35-18.29 42.21-28.4 71.15-32.01 6.15-0.42 7.3-4.76 7.3-7.54v-143.6c0-4.71-3.15-8.56-7.23-8.39zm-49.4 105.1-52.24 33.34c-3.62 2.37-7.25-0.34-7.25-4.26v-65.23c0-3.92 3.56-5.34 6.64-3.4l52.78 31.7c3.49 2.23 3 6.01 0.07 7.85z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAprendoleIcon5);
export default __webpack_public_path__ + "static/media/AprendoleIcon5.f43010b704629a69a938d2ea5c0af5eb.svg";
export { ForwardRef as ReactComponent };